import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'leaflet/dist/leaflet.css';
import Avatar from '../../services/Avatar';
import { Shield, Search, Globe2, AlertTriangle, Database, Key, Lock, 
  Globe, Radar, Cpu, ChevronDown, LogOut,
  Server,  
  Calendar, 
  Building,ScanSearch,ScanLine,Code2,
  Eye, 
  LineChart,BellRing,Play,FileSearch,
  Settings, 
  Bell, 
  Wifi, 
  Bug, 
  Users, 
  TrendingUp, 
  History, User,
  Loader2, 
  ShieldCheck, 
  FileWarning, 
  RefreshCcw, 
  Download, 
  MoreHorizontal, 
  AtSign, 
  Copy, 
  ExternalLink, 
  CheckCircle, 
  XCircle, 
  ShieldAlert, 
  EyeOff, 
  Map, 
  FileText, 
  HelpCircle ,
  MapPin,
  Mail,    
  Network, Signal, Clock } from 'lucide-react';
import PhoneNumber from './TraceMaster/Phonenumber';
import HelpCenter from './TraceMaster/HelpCenter'; 
import Footer from './TraceMaster/Footer';


const TraceMaster = () => {
  const [activeTab, setActiveTab] = useState('phone');
  const [currentUser, setCurrentUser] = useState(null);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [scanStage, setScanStage] = useState(0);
  const [scanDetails, setScanDetails] = useState([]);
  const [data, setData] = useState(null);
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showCookiesModal, setShowCookiesModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
    const [scanPhase, setScanPhase] = useState('');
    const [currentPhase, setCurrentPhase] = useState(0);
    const [scanPhases, setScanPhases] = useState([
      { message: 'Initializing forensic tools...' },
      { message: 'Querying DNS records...' },
      { message: 'Retrieving WHOIS data...' },
      { message: 'Analyzing email headers...' },
      { message: 'Checking threat databases...' },
      { message: 'Compiling final report...' },
    ]);

    const Skeleton = ({ width = "w-8", height = "h-8", rounded = "rounded-full" }) => (
      <div className={`${width} ${height} ${rounded} bg-gray-300 animate-pulse`} />
    );
  

    const simulateScan = () => {
      let progress = 0;
      // Calculate how many increments are needed over 5 minutes
      const totalDuration = 300000; // 5 minutes in milliseconds
      const increments = 50; // You can adjust this for more or less smooth updates
      const incrementDuration = totalDuration / increments;
    
      const interval = setInterval(() => {
        progress += (100 / increments); // Increment to ensure it reaches 100% eventually
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setScanProgress(progress);
        
        // Update phases based on progress
        const phaseIndex = Math.floor(progress / (100 / scanPhases.length));
        setCurrentPhase(phaseIndex);
        setScanPhase(scanPhases[phaseIndex]?.message || '');
      }, incrementDuration); // Update every incrementDuration milliseconds
      
      return interval;
    };
    

      const clearState = () => {
        setInput('');
        setResult(null);
        setScanStage(0);
        setScanDetails([]);
      };

      const handleTabChange = (tab) => {
        setActiveTab(tab);
        clearState();
      };

      

      const validateEmailFormat = (email) => {
        // Simple regex to validate email format
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
      };

      useEffect(() => {
        const controller = new AbortController();
        const fetchUserProfile = async () => {
            try {
                const response = await axios.get('/users/me', { 
                    withCredentials: true,
                    signal: controller.signal // Attach signal to cancel duplicate requests
                });
                setCurrentUser(response.data);
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    console.error('Error fetching user profile:', error);
                }
            }
        };
    
        fetchUserProfile();
    
        return () => controller.abort(); 
    }, []);
    
    const handleLogout = async () => {
      try {
        const response = await fetch('/d-auth/logout', {
          method: 'POST', // or 'GET', depending on your backend implementation
          credentials: 'include', // include cookies with the request
          headers: {
            'Content-Type': 'application/json',
          },
        });
    
        if (response.ok) {       
          
          window.location.href = '/'; 
        } else {
          // If there's an error during logout
          const errorData = await response.json();
          //console.error('Logout failed', errorData);
          alert( errorData ||'Logout failed. Please try again.');
        }
      } catch (error) {
        //console.error('Error during logout:', error);
        alert('An error occurred. Please try again.');
      }
    };


  const handleAnalyzeClick = async () => {
      
      const scanInterval = simulateScan();
        // Validate input
        if (!input || !validateEmailFormat(input)) {
            alert("Please enter a valid email.");
            return;
        }

    
      setScanProgress(0);
      setCurrentPhase(0);

    setLoading(true);
        setData(null); // Reset data on new request

        try {
            const response = await fetch('/v1/lookup/email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: input }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                alert(errorData.error || 'Something went wrong!');
                return;
            }

            const fetchedData = await response.json();
            setData(fetchedData); // Set fetched data to state

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
            alert('An unexpected error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
};



  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 to-slate-900">
      {/* Trace Master Command Center Header */}
        {/* Fixed Header */}
      <header className="sticky top-0 z-50 bg-gradient-to-r from-gray-900 to-gray-950 border-b border-blue-900/30 shadow-2xl shadow-blue-500/5">
        <div className="max-w-8xl mx-auto px-6 py-3">
          <div className="flex justify-between items-center">
            {/* Logo and Branding */}
            <div className="flex items-center space-x-4">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-blue-500/10 blur-md"></div>
                <div className="relative flex items-center justify-center w-12 h-12 bg-gray-800 rounded-lg border border-gray-700/50">
                  <Radar className="w-6 h-6 text-blue-400" />
                  <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900 animate-pulse"></div>
                </div>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-white tracking-tight">
                  <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">TRACE</span>
                  <span className="text-gray-300">MASTER</span>
                </h1>
                <p className="text-gray-400 text-xs font-mono tracking-wider">Digital Forensic Suite v5.1.3</p>
              </div>
            </div>

            {/* System Status */}
            <div className="hidden lg:flex items-center space-x-6">
              <div className="flex items-center space-x-4 bg-gray-900/60 px-4 py-2 rounded-xl border border-gray-800/50 backdrop-blur-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-xs font-mono text-gray-300 tracking-wider">SYSTEM: <span className="text-green-400">SECURE</span></span>
                </div>
                <div className="h-4 w-px bg-gray-700/50"></div>
                <div className="flex items-center space-x-2">
                  <Server className="w-4 h-4 text-blue-400" />
                  <span className="text-xs font-mono text-gray-300 tracking-wider">CLUSTER: <span className="text-blue-400">9 NODES</span></span>
                </div>
                <div className="h-4 w-px bg-gray-700/50"></div>
                <div className="flex items-center space-x-2">
                  <Cpu className="w-4 h-4 text-purple-400" />
                  <span className="text-xs font-mono text-gray-300 tracking-wider">AI: <span className="text-purple-400">ACTIVE</span></span>
                </div>
              </div>
            </div>

            {/* User Controls */}
            <div className="flex items-center space-x-3">
              {/* Quick Access Buttons */}
              <div className="hidden md:flex items-center space-x-2">
                <button 
                onClick={() => setShowHelpPopup(true)}
                className="p-2 bg-gray-800/50 hover:bg-gray-700/50 rounded-xl text-gray-300 hover:text-blue-400 transition-all duration-200 border border-gray-800/30 hover:border-blue-500/30"
                title="Help & Information"
              >
                <HelpCircle className="w-5 h-5" />
              </button>
                <button className="p-2 bg-gray-800/50 hover:bg-gray-700/50 rounded-xl text-gray-300 hover:text-yellow-400 transition-all duration-200 border border-gray-800/30 hover:border-yellow-500/30">
                  <Bell className="w-5 h-5" />
                </button>
                <button className="p-2 bg-gray-800/50 hover:bg-gray-700/50 rounded-xl text-gray-300 hover:text-green-400 transition-all duration-200 border border-gray-800/30 hover:border-green-500/30">
                  <Settings className="w-5 h-5" />
                </button>
              </div>

              {/* User Profile Dropdown */}
              <div className="relative group">
                <button className="flex items-center space-x-2 bg-gray-800/70 hover:bg-gray-700/70 pl-3 pr-2 py-1.5 rounded-xl border border-gray-700/50 transition-all duration-200">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-white text-sm font-medium">
                  
                  {currentUser ? (
                      <>
                        <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                      </>
                    ) : (
                      <div className="flex items-center gap-2">
                        <Skeleton width="w-10 h-10" rounded="rounded-full" /> {/* Skeleton for Avatar */}
                        <div className="flex flex-col">
                          <Skeleton width="w-20" height="h-3" rounded="rounded-md" /> {/* Skeleton for Name */}
                          <Skeleton width="w-16" height="h-3" rounded="rounded-md" /> {/* Skeleton for Role */}
                        </div>
                      </div>
                    )}
                  
                  </div>
                  <div className="hidden md:block">
                    <ChevronDown className="w-4 h-4 text-gray-400 group-hover:text-blue-400 transition-colors duration-200" />
                  </div>
                </button>

                
              {/* Dropdown Menu */}
              <div className="absolute right-0 mt-2 w-56 origin-top-right bg-gray-900/95 backdrop-blur-lg rounded-xl shadow-lg shadow-black/50 border border-gray-800/50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform group-hover:translate-y-0 translate-y-1 z-50">
                <div className="p-4 border-b border-gray-800/50">
                  <div className="flex items-center space-x-3">
                    {currentUser ? (
                      <>
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-white text-sm font-medium">
                          <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                        </div>
                        <div>
                          <span className="text-sm text-gray-100 font-medium">{currentUser.first_name} {currentUser.last_name}</span>
                          <span className="text-xs text-gray-400">{currentUser.role}</span>
                        </div>
                      </>
                    ) : (
                      <div className="flex items-center gap-2">
                        <Skeleton width="w-10 h-10" rounded="rounded-full" /> {/* Skeleton for Avatar */}
                        <div className="flex flex-col">
                          <Skeleton width="w-20" height="h-3" rounded="rounded-md" /> {/* Skeleton for Name */}
                          <Skeleton width="w-16" height="h-3" rounded="rounded-md" /> {/* Skeleton for Role */}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
           
                  <div className="p-2">
                    <a href="#" className="flex items-center px-3 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-gray-800/50 rounded-lg transition-colors duration-150">
                      <User className="w-4 h-4 mr-2" />
                      Profile Settings
                    </a>
                    <a href="#" className="flex items-center px-3 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-gray-800/50 rounded-lg transition-colors duration-150">
                      <Key className="w-4 h-4 mr-2" />
                      Security
                    </a>
                    <a href="#" className="flex items-center px-3 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-gray-800/50 rounded-lg transition-colors duration-150">
                      <History className="w-4 h-4 mr-2" />
                      Activity Log
                    </a>
                  </div>
                  <div className="p-2 border-t border-gray-800/50">
                    <button 
                      onClick={handleLogout} 
                      className="flex items-center px-3 py-2 text-sm text-red-400 hover:text-red-500 hover:bg-gray-800/50 rounded-lg transition-colors duration-150"
                    >
                      <LogOut className="w-4 h-4 mr-2" />
                      Sign Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Help Popup Modal */}
      {showHelpPopup && (
        <HelpCenter showHelpPopup={showHelpPopup} setShowHelpPopup={setShowHelpPopup} />
      )}

    {/* Main Content */}
    <main className="max-w-7xl mx-auto px-6 py-6">
      {/* Analysis Control Panel */}
      <div className="grid grid-cols-12 gap-6 mb-6">
        <div className="col-span-8">
          <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-xl p-1 mb-6 shadow-lg shadow-blue-500/5">
            <div className="flex space-x-1 overflow-x-auto">
              {[
                { id: 'phone', icon: Signal, label: 'Mobile Analysis', desc: 'Cellular & Device Forensics' },
                { id: 'email', icon: Globe2, label: 'Email Analysis', desc: 'Email Infrastructure Intelligence' },
                { id: 'network', icon: Wifi, label: 'Network Analysis', desc: 'Traffic & Packet Analysis' },
                { id: 'malware', icon: Bug, label: 'Malware Detection', desc: 'Binary & Behavior Analysis' },
                { id: 'social', icon: Users, label: 'Social Media', desc: 'Digital Footprint Analysis' },
              ].map(({ id, icon: Icon, label, desc }) => (
                <button
                  key={id}
                  onClick={() => handleTabChange(id)}
                  className={`p-4 rounded-lg transition-all flex-1 ${
                    activeTab === id 
                      ? 'bg-gradient-to-br from-blue-900/40 to-indigo-900/40 border border-blue-500/50 text-white'
                      : 'bg-slate-800/70 hover:bg-slate-800 text-slate-300'
                  }`}
                >
                  <div className="flex flex-col items-center text-center">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${
                      activeTab === id ? 'bg-blue-900/50' : 'bg-slate-700/50'
                    }`}>
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="font-medium">{label}</div>
                      <div className="text-xs text-slate-400">{desc}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
  
        <div className="col-span-4">
          <div className="grid grid-cols-2 gap-3 h-full">
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-4 shadow-lg flex flex-col justify-between">
              <div className="text-xs text-slate-400 mb-1">ANALYZED ENTITIES</div>
              <div className="text-2xl font-bold text-white">1,342</div>
              <div className="flex items-center text-xs text-green-400">
                <TrendingUp className="w-3 h-3 mr-1" />
                <span>+24 today</span>
              </div>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-4 shadow-lg flex flex-col justify-between">
              <div className="text-xs text-slate-400 mb-1">THREATS DETECTED</div>
              <div className="text-2xl font-bold text-red-400">87</div>
              <div className="flex items-center text-xs text-yellow-400">
                <AlertTriangle className="w-3 h-3 mr-1" />
                <span>5 critical</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      {/* Analysis Input Area */}
      
       
  
      {activeTab === 'email' && (
        <div className="space-y-6">
          {/* Enhanced Input Section */}
          <div className="bg-gradient-to-br from-slate-900/80 to-slate-900/50 backdrop-blur-md border border-slate-800 rounded-2xl p-6 shadow-2xl shadow-blue-900/20">
            <div className="flex flex-col md:flex-row md:items-end space-y-4 md:space-y-0 md:space-x-6">
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="relative">
                    <Search className="w-5 h-5 text-blue-400" />
                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                  </div>
                  <h3 className="text-sm font-medium text-slate-300 tracking-wider uppercase font-mono">
                    <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                      Email Forensic Analysis
                    </span>
                  </h3>
                </div>
                
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-900/30 to-purple-900/20 rounded-xl blur-sm group-hover:blur-md transition-all duration-300"></div>
                  <div className="relative flex items-center bg-slate-800/80 border border-slate-700 rounded-xl overflow-hidden">
                    <div className="px-4 py-3 bg-slate-800 border-r border-slate-700 flex items-center">
                      <span className="text-slate-400 text-sm font-mono tracking-wider">@</span>
                    </div>
                    <input
                      type="email"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      className="flex-1 bg-transparent px-4 py-3.5 text-white placeholder-slate-500 focus:outline-none font-mono text-sm tracking-wider"
                      placeholder="target@domain.com"
                    />
                    <div className="px-3 bg-slate-800 border-l border-slate-700 h-full flex items-center">
                      <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex space-x-3">
                <button
                  className="px-4 py-3 bg-slate-800/80 hover:bg-slate-700/80 text-slate-300 rounded-xl font-medium border border-slate-700 flex items-center justify-center transition-all duration-300 hover:shadow-lg hover:shadow-blue-900/20"
                  title="Search History"
                >
                  <History className="w-5 h-5" />
                  <span className="sr-only">History</span>
                </button>
                <button
                  onClick={handleAnalyzeClick}
                  disabled={loading}
                  className="px-6 py-3.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white rounded-xl font-medium disabled:from-slate-800 disabled:to-slate-700 disabled:text-slate-500 flex items-center transition-all duration-300 hover:shadow-lg hover:shadow-blue-900/30 group"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                      <span className="font-mono tracking-wider">SCANNING</span>
                    </>
                  ) : (
                    <>
                      <div className="relative mr-2">
                        <ScanSearch className="w-5 h-5" />
                        <div className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-blue-400 rounded-full animate-pulse group-hover:bg-green-400"></div>
                      </div>
                      <span className="font-mono tracking-wider">INITIATE SCAN</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Advanced Scanning Animation */}
          {loading && (
            <div className="bg-gradient-to-br from-slate-900/50 to-slate-900/30 border border-slate-800 rounded-2xl p-6 shadow-2xl shadow-blue-900/10 overflow-hidden">
              {/* Header with animated elements */}
              <div className="mb-6 flex justify-between items-center">
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    <ScanLine className="w-6 h-6 text-blue-400 animate-pulse" />
                    <div className="absolute -bottom-1 -right-1 w-2 h-2 bg-blue-500 rounded-full animate-ping"></div>
                  </div>
                  <h3 className="text-xl font-medium text-white">
                    <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                      Forensic Analysis
                    </span>
                  </h3>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="text-xs font-mono px-3 py-1.5 bg-slate-800/50 rounded-full text-blue-400 border border-slate-700 flex items-center">
                    <div className="w-2 h-2 rounded-full bg-blue-500 mr-2 animate-pulse"></div>
                    {scanPhase || 'INITIALIZING'}
                  </div>
                  <div className="text-xs font-mono px-3 py-1.5 bg-slate-800/50 rounded-full text-purple-400 border border-slate-700">
                    {Math.floor(scanProgress)}%
                  </div>
                </div>
              </div>

              {/* Animated Progress Bar */}
              <div className="w-full bg-slate-800/50 rounded-full h-2 mb-8 relative overflow-hidden">
                <div 
                  className="bg-gradient-to-r from-blue-500 via-purple-500 to-blue-600 h-2 rounded-full absolute top-0 left-0 transition-all duration-500 ease-out"
                  style={{ width: `${scanProgress}%` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-white/30 to-white/0 opacity-70 animate-progress-shine"></div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-purple-900/20 animate-pulse-slow"></div>
              </div>

              {/* Animated Scanning Visualization */}
              <div className="relative h-64 rounded-xl bg-slate-900/50 border border-slate-800/50 mb-6 overflow-hidden">
                {/* Background Grid Pattern */}
                <div className="absolute inset-0 opacity-20" style={{
                  backgroundImage: 'linear-gradient(to right, #64748b 1px, transparent 1px), linear-gradient(to bottom, #64748b 1px, transparent 1px)',
                  backgroundSize: '20px 20px'
                }}></div>
                
                {/* Animated Scanning Elements */}
                <div className="absolute inset-0 flex items-center justify-center">
                  {/* Rotating Radar */}
                  <div className="relative w-40 h-40">
                    <div className="absolute inset-0 rounded-full border-2 border-blue-500/30"></div>
                    <div className="absolute inset-4 rounded-full border-2 border-blue-500/20"></div>
                    <div className="absolute inset-8 rounded-full border-2 border-blue-500/10"></div>
                    <div className="absolute top-1/2 left-1/2 w-1 h-8 bg-blue-500 rounded-full transform -translate-x-1/2 -translate-y-1/2 origin-top rotate-0 animate-radar-scan"></div>
                    
                    {/* Floating Database Icons */}
                    {[1, 2, 3, 4].map((i) => (
                      <div 
                        key={i}
                        className="absolute w-8 h-8 bg-slate-800/80 border border-slate-700 rounded-lg flex items-center justify-center text-blue-400"
                        style={{
                          top: `${Math.sin(Date.now()/1000 + i) * 30 + 50}%`,
                          left: `${Math.cos(Date.now()/1000 + i) * 30 + 50}%`,
                          transform: `scale(${1 + Math.sin(Date.now()/1000 + i) * 0.2})`
                        }}
                      >
                        <Database className="w-4 h-4" />
                      </div>
                    ))}
                  </div>
                  
                  {/* Floating File Icons */}
                  {[1, 2, 3, 4, 5].map((i) => (
                    <div 
                      key={i}
                      className="absolute w-6 h-6 bg-slate-800/80 border border-slate-700 rounded flex items-center justify-center text-purple-400 animate-float"
                      style={{
                        top: `${Math.random() * 80 + 10}%`,
                        left: `${Math.random() * 80 + 10}%`,
                        animationDelay: `${i * 0.5}s`,
                        animationDuration: `${5 + Math.random() * 10}s`
                      }}
                    >
                      <FileSearch className="w-3 h-3" />
                    </div>
                  ))}
                </div>
                
                {/* Scanning Dots */}
                <div className="absolute inset-0 pointer-events-none">
                  {Array.from({ length: 20 }).map((_, i) => (
                    <div 
                      key={i}
                      className="absolute w-1 h-1 bg-blue-400 rounded-full animate-pulse"
                      style={{
                        top: `${Math.random() * 100}%`,
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 2}s`,
                        opacity: Math.random() * 0.5 + 0.3
                      }}
                    ></div>
                  ))}
                </div>
              </div>

              {/* Scanning Modules */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                {[
                  { 
                    name: 'DNS RECORDS', 
                    icon: <Globe className="w-5 h-5" />,
                    status: scanProgress > 20,
                    description: 'Querying domain records'
                  },
                  { 
                    name: 'WHOIS DATA', 
                    icon: <Database className="w-5 h-5" />,
                    status: scanProgress > 40,
                    description: 'Retrieving registration data'
                  },
                  { 
                    name: 'HEADER ANALYSIS', 
                    icon: <Code2 className="w-5 h-5" />,
                    status: scanProgress > 60,
                    description: 'Inspecting email metadata'
                  },
                  { 
                    name: 'THREAT ASSESSMENT', 
                    icon: <ShieldAlert className="w-5 h-5" />,
                    status: scanProgress > 80,
                    description: 'Checking threat databases'
                  },
                ].map((module, index) => (
                  <div 
                    key={index}
                    className={`p-4 rounded-xl border ${module.status ? 'border-green-500/30 bg-green-900/10' : 'border-slate-700/50 bg-slate-800/30'} transition-all duration-500 hover:shadow-lg ${module.status ? 'hover:shadow-green-900/20' : 'hover:shadow-slate-900/20'}`}
                  >
                    <div className="flex items-start space-x-3">
                      <div className={`p-2 rounded-lg ${module.status ? 'bg-green-500/20 text-green-400' : 'bg-slate-700/50 text-slate-400'} transition-all duration-300`}>
                        {module.icon}
                      </div>
                      <div>
                        <h4 className={`text-sm font-medium ${module.status ? 'text-green-400' : 'text-slate-400'} mb-1`}>
                          {module.name}
                        </h4>
                        <p className="text-xs text-slate-500 font-mono">
                          {module.description}
                        </p>
                        <div className="mt-2 h-1 w-full bg-slate-700/50 rounded-full overflow-hidden">
                          <div 
                            className={`h-full ${module.status ? 'bg-gradient-to-r from-green-500 to-green-600' : 'bg-slate-600'} rounded-full transition-all duration-1000`}
                            style={{ width: module.status ? '100%' : `${20 + index * 10}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Console Output */}
              <div className="bg-black/70 rounded-xl p-4 border border-slate-800/50 font-mono text-sm text-slate-300 h-40 overflow-y-auto">
                <div className="text-green-400/90 mb-2">$ forensic-scan --email {input} --deep-scan --threat-intel</div>
                {scanPhases.map((phase, index) => (
                  <div 
                    key={index}
                    className={`${index <= currentPhase ? 'text-slate-300' : 'text-slate-600'} flex items-start mb-1`}
                  >
                    <span className="text-blue-400/80 mr-2">{'>>'}</span>
                    <span>
                      {phase.message}{' '}
                      {index <= currentPhase && (
                        <span className="text-green-400/80">[✓]</span>
                      )}
                    </span>
                  </div>
                ))}
                {scanProgress >= 100 && (
                  <div className="text-green-400/90 mt-2">
                    $ Scan completed. Found {Math.floor(Math.random() * 15) + 5} artifacts.
                  </div>
                )}
              </div>
            </div>
          )}

          {/* CSS Animations */}
          <style >{`
            @keyframes radar-scan {
              0% { transform: translateX(-50%) translateY(-50%) rotate(0deg); }
              100% { transform: translateX(-50%) translateY(-50%) rotate(360deg); }
            }
            @keyframes float {
              0%, 100% { transform: translateY(0) translateX(0); }
              50% { transform: translateY(-20px) translateX(10px); }
            }
            @keyframes progress-shine {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(100%); }
            }
            @keyframes pulse-slow {
              0%, 100% { opacity: 0.8; }
              50% { opacity: 1; }
            }
            .animate-radar-scan {
              animation: radar-scan 4s linear infinite;
            }
            .animate-float {
              animation: float linear infinite;
            }
            .animate-progress-shine {
              animation: progress-shine 2s linear infinite;
            }
            .animate-pulse-slow {
              animation: pulse-slow 3s ease-in-out infinite;
            }
          `}</style>
        </div>
      )}
          
  
      {/* Results Dashboard */}
      {data && activeTab === 'email' && (
        <div className="space-y-6">
          {/* Quick Stats */}
          <div className="grid grid-cols-4 gap-4">
            {[
              { label: 'Security Rating', value: '78/100', icon: ShieldCheck, color: 'text-yellow-500', trend: 'neutral' },
              { label: 'Potential Threats', value: '3', icon: AlertTriangle, color: 'text-orange-500', trend: 'negative' },
              { label: 'Encryption Level', value: 'TLS 1.3', icon: Lock, color: 'text-green-500', trend: 'positive' },
              { label: 'Data Breaches', value: '0', icon: FileWarning, color: 'text-blue-500', trend: 'positive' }
            ].map(item => (
              <div key={item.label} className="bg-slate-900/70 border border-slate-800 rounded-xl p-4 shadow-lg flex items-center space-x-4">
                <div className={`w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center ${item.color}`}>
                  <item.icon className="w-6 h-6" />
                </div>
                <div>
                  <div className="text-xs text-slate-400">{item.label}</div>
                  <div className="text-xl font-bold text-white">{item.value}</div>
                  <div className={`text-xs ${
                    item.trend === 'positive' ? 'text-green-400' : 
                    item.trend === 'negative' ? 'text-red-400' : 'text-slate-400'
                  }`}>
                    {item.trend === 'positive' ? 'Secure' : 
                     item.trend === 'negative' ? 'Attention needed' : 'Standard'}
                  </div>
                </div>
              </div>
            ))}
          </div>
  
          {/* Detailed Analysis Panels */}
          <div className="grid grid-cols-2 gap-6">
            {/* Email Intelligence */}
            <div className="bg-slate-900/70 border border-slate-800 rounded-xl shadow-lg overflow-hidden">
              <div className="bg-slate-800 px-6 py-4 border-b border-slate-700 flex justify-between items-center">
                <div className="flex items-center">
                  <Mail className="w-5 h-5 text-blue-400 mr-2" />
                  <h3 className="text-lg font-medium text-white">Email Intelligence</h3>
                </div>
                <div className="flex space-x-2">
                  <button className="p-1 text-slate-400 hover:text-white">
                    <RefreshCcw className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <Download className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <MoreHorizontal className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="p-6 space-y-4">
                <div className="space-y-2">
                  <div className="flex justify-between items-center p-3 bg-slate-800/50 rounded-lg">
                    <div className="flex items-center">
                      <AtSign className="w-4 h-4 text-blue-400 mr-2" />
                      <span className="text-sm text-slate-300">Email Address</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-mono bg-slate-900 px-2 py-1 rounded text-white">{data.email}</span>
                      <button className="text-slate-400 hover:text-white">
                        <Copy className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center p-3 bg-slate-800/50 rounded-lg">
                    <div className="flex items-center">
                      <Globe className="w-4 h-4 text-blue-400 mr-2" />
                      <span className="text-sm text-slate-300">Domain</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-mono bg-slate-900 px-2 py-1 rounded text-white">{data.domain}</span>
                      <button className="text-slate-400 hover:text-white">
                        <ExternalLink className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center p-3 bg-slate-800/50 rounded-lg">
                    <div className="flex items-center">
                      <Server className="w-4 h-4 text-blue-400 mr-2" />
                      <span className="text-sm text-slate-300">SMTP Server</span>
                    </div>
                    <div className="flex items-center">
                      {data.smtp_server_exists ? (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-900/50 text-green-400 border border-green-700/50">
                          <CheckCircle className="w-3 h-3 mr-1" /> Valid
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-red-900/50 text-red-400 border border-red-700/50">
                          <XCircle className="w-3 h-3 mr-1" /> Invalid
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center p-3 bg-slate-800/50 rounded-lg">
                    <div className="flex items-center">
                      <ShieldAlert className="w-4 h-4 text-blue-400 mr-2" />
                      <span className="text-sm text-slate-300">SPF Record</span>
                    </div>
                    <div className="flex items-center">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-900/50 text-green-400 border border-green-700/50">
                        <CheckCircle className="w-3 h-3 mr-1" /> Valid
                      </span>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center p-3 bg-slate-800/50 rounded-lg">
                    <div className="flex items-center">
                      <Lock className="w-4 h-4 text-blue-400 mr-2" />
                      <span className="text-sm text-slate-300">DKIM Signature</span>
                    </div>
                    <div className="flex items-center">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-yellow-900/50 text-yellow-400 border border-yellow-700/50">
                        <AlertTriangle className="w-3 h-3 mr-1" /> Partial
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="pt-2">
                  <div className="text-xs text-slate-400 uppercase mb-2">Advanced Tests</div>
                  <div className="grid grid-cols-2 gap-2">
                    {['Sender Reputation', 'Spam List Status', 'Content Analysis', 'Authentication'].map(test => (
                      <button key={test} className="text-sm bg-slate-800 hover:bg-slate-700 text-slate-300 p-2 rounded-lg flex items-center justify-center">
                        <Play className="w-3 h-3 mr-1" /> {test}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
            {/* DNS Intelligence */}
            <div className="bg-slate-900/70 border border-slate-800 rounded-xl shadow-lg overflow-hidden">
              <div className="bg-slate-800 px-6 py-4 border-b border-slate-700 flex justify-between items-center">
                <div className="flex items-center">
                  <Database className="w-5 h-5 text-purple-400 mr-2" />
                  <h3 className="text-lg font-medium text-white">DNS Intelligence</h3>
                </div>
                <div className="flex space-x-2">
                  <button className="p-1 text-slate-400 hover:text-white">
                    <RefreshCcw className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <Download className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <MoreHorizontal className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="flex space-x-2 mb-4">
                  {['MX', 'NS', 'A', 'TXT', 'CNAME'].map(type => (
                    <button 
                      key={type}
                      className={`px-3 py-1 text-xs rounded-full ${
                        type === 'MX' 
                          ? 'bg-purple-900/30 border border-purple-700/50 text-purple-400' 
                          : 'bg-slate-800 border border-slate-700 text-slate-400 hover:text-white'
                      }`}
                    >
                      {type}
                    </button>
                  ))}
                </div>
                
                <div className="space-y-3 max-h-64 overflow-y-auto custom-scrollbar pr-2">
                  {data.dns_records.mx.map((record, index) => (
                    <div key={index} className="bg-slate-800/80 border border-slate-700 rounded-lg p-3 text-sm">
                      <div className="flex justify-between items-start">
                        <div className="flex items-center">
                          <div className="w-6 h-6 rounded-full bg-purple-900/50 text-purple-400 flex items-center justify-center text-xs mr-2">
                            {index + 1}
                          </div>
                          <div className="font-mono text-white">{record}</div>
                        </div>
                        <div className="flex space-x-1">
                          <button className="p-1 text-slate-500 hover:text-slate-300">
                            <Search className="w-3 h-3" />
                          </button>
                          <button className="p-1 text-slate-500 hover:text-slate-300">
                            <Copy className="w-3 h-3" />
                          </button>
                        </div>
                      </div>
                      <div className="mt-2 ml-8 text-xs text-slate-400 flex items-center">
                        <Clock className="w-3 h-3 mr-1" /> TTL: 3600s 
                        <span className="mx-2">•</span>
                        <Shield className="w-3 h-3 mr-1" /> Priority: 10
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="mt-4 pt-4 border-t border-slate-800">
                  <div className="flex justify-between items-center">
                    <div className="text-xs text-slate-400">DNS PROPAGATION STATUS</div>
                    <div className="text-xs text-green-400">FULLY PROPAGATED</div>
                  </div>
                  <div className="mt-2 bg-slate-800 rounded-full h-2">
                    <div className="bg-gradient-to-r from-green-500 to-green-400 h-2 rounded-full w-full"></div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* WHOIS Intelligence */}
            <div className="bg-slate-900/70 border border-slate-800 rounded-xl shadow-lg overflow-hidden">
              <div className="bg-slate-800 px-6 py-4 border-b border-slate-700 flex justify-between items-center">
                <div className="flex items-center">
                  <Globe className="w-5 h-5 text-blue-400 mr-2" />
                  <h3 className="text-lg font-medium text-white">WHOIS Intelligence</h3>
                </div>
                <div className="flex space-x-2">
                  <button className="p-1 text-slate-400 hover:text-white">
                    <RefreshCcw className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <Download className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <MoreHorizontal className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { label: 'Organization', value: data.whois.organization, icon: Building, color: 'text-blue-400' },
                    { label: 'Registrar', value: data.whois.registrar, icon: Shield, color: 'text-indigo-400' },
                    { label: 'Created', value: data.whois.creation_date, icon: Calendar, color: 'text-green-400' },
                    { label: 'Expires', value: data.whois.expiration_date, icon: Calendar, color: 'text-red-400' },
                    { label: 'Country', value: data.whois.country, icon: MapPin, color: 'text-yellow-400' },
                    { label: 'Privacy', value: 'Protected', icon: EyeOff, color: 'text-purple-400' },
                  ].map(({ label, value, icon: Icon, color }) => (
                    <div key={label} className="flex items-start space-x-3 bg-slate-800/60 p-3 rounded-lg border border-slate-700">
                      <div className={`w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center ${color}`}>
                        <Icon className="w-4 h-4" />
                      </div>
                      <div>
                        <div className="text-xs text-slate-400">{label}</div>
                        <div className="text-sm text-white font-medium">{value}</div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="mt-4 bg-slate-800/60 rounded-lg border border-slate-700 p-4">
                  <div className="text-xs text-slate-400 mb-2">DOMAIN AGE ANALYSIS</div>
                  <div className="flex items-center">
                    <div className="flex-1 h-2 bg-slate-700 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-green-500 to-blue-500 w-3/4"></div>
                    </div>
                    <span className="text-white text-xs ml-3">3.2 years</span>
                  </div>
                  <div className="mt-2 text-xs text-slate-400">Domain age indicates established presence (moderate risk level)</div>
                </div>
              </div>
            </div>
            
            {/* Network Intelligence */}
            <div className="bg-slate-900/70 border border-slate-800 rounded-xl shadow-lg overflow-hidden">
              <div className="bg-slate-800 px-6 py-4 border-b border-slate-700 flex justify-between items-center">
                <div className="flex items-center">
                  <Network className="w-5 h-5 text-orange-400 mr-2" />
                  <h3 className="text-lg font-medium text-white">Network Intelligence</h3>
                </div>
                <div className="flex space-x-2">
                  <button className="p-1 text-slate-400 hover:text-white">
                    <RefreshCcw className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <Download className="w-4 h-4" />
                  </button>
                  <button className="p-1 text-slate-400 hover:text-white">
                    <MoreHorizontal className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="space-y-4">
                  <div className="flex items-center justify-between bg-slate-800/60 p-4 rounded-lg border border-slate-700">
                    <div className="flex items-center">
                      <Server className="w-5 h-5 text-orange-400 mr-3" />
                      <div>
                        <div className="text-xs text-slate-400">IP ADDRESS</div>
                        <div className="text-white font-mono">{data.ip_info.ip}</div>
                      </div>
                    </div>
                    <div className="flex space-x-2">
                      <button className="px-2 py-1 text-xs bg-slate-700 hover:bg-slate-600 text-slate-300 rounded">
                        <Search className="w-3 h-3 mr-1 inline" /> Trace
                      </button>
                      <button className="px-2 py-1 text-xs bg-slate-700 hover:bg-slate-600 text-slate-300 rounded">
                        <Map className="w-3 h-3 mr-1 inline" /> Locate
                      </button>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { label: 'ASN', value: data.ip_info.asn, icon: Network },
                      { label: 'Network', value: data.ip_info.network, icon: Wifi },
                      { label: 'Country', value: data.ip_info.country, icon: Globe },
                      { label: 'Description', value: data.ip_info.description, icon: FileText },
                    ].map(({ label, value, icon: Icon }) => (
                      <div key={label} className="bg-slate-800/60 p-3 rounded-lg border border-slate-700 flex justify-between items-center">
                        <div className="flex items-center">
                          <Icon className="w-4 h-4 text-orange-400 mr-2" />
                          <span className="text-xs text-slate-400">{label}</span>
                      </div>
                      <span className="text-sm text-white font-medium">{value}</span>
                    </div>
                  ))}
                </div>
                
                <div className="bg-slate-800/60 p-4 rounded-lg border border-slate-700">
                  <div className="flex justify-between items-center mb-3">
                    <div className="text-xs text-slate-400">RISK ASSESSMENT</div>
                    <div className="px-2 py-1 text-xs bg-yellow-900/50 text-yellow-400 rounded-full border border-yellow-700/50">
                      MEDIUM RISK
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    {[
                      { label: 'Blacklist Status', status: 'Clean', color: 'text-green-400' },
                      { label: 'Malicious Activity', status: 'None Detected', color: 'text-green-400' },
                      { label: 'Reputation Score', status: '87/100', color: 'text-yellow-400' },
                    ].map(item => (
                      <div key={item.label} className="flex justify-between items-center">
                        <span className="text-xs text-slate-400">{item.label}</span>
                        <span className={`text-xs ${item.color}`}>{item.status}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Interactive Timeline */}
        <div className="bg-slate-900/70 border border-slate-800 rounded-xl shadow-lg overflow-hidden">
          <div className="bg-slate-800 px-6 py-4 border-b border-slate-700 flex justify-between items-center">
            <div className="flex items-center">
              <LineChart className="w-5 h-5 text-green-400 mr-2" />
              <h3 className="text-lg font-medium text-white">Activity Timeline</h3>
            </div>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2">
                <span className="text-xs text-slate-400">TIMESPAN:</span>
                <select className="bg-slate-900 border border-slate-700 rounded text-xs text-white py-1 px-2">
                  <option>Last 30 Days</option>
                  <option>Last 7 Days</option>
                  <option>Last 24 Hours</option>
                </select>
              </div>
              <div className="flex space-x-2">
                <button className="p-1 text-slate-400 hover:text-white">
                  <RefreshCcw className="w-4 h-4" />
                </button>
                <button className="p-1 text-slate-400 hover:text-white">
                  <Download className="w-4 h-4" />
                </button>
                <button className="p-1 text-slate-400 hover:text-white">
                  <MoreHorizontal className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
          <div className="p-6">
            <div className="relative">
              {/* Timeline visualization */}
              <div className="h-24 w-full bg-slate-800/40 rounded-lg border border-slate-700 relative">
                {/* Activity points */}
                {[15, 30, 45, 65, 80].map((position, index) => (
                  <div key={index} className="absolute top-1/2 transform -translate-y-1/2" style={{ left: `${position}%` }}>
                    <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-xs text-slate-400 whitespace-nowrap">
                      {['Domain Created', 'MX Updated', 'SSL Updated', 'IP Changed', 'Recent Login'][index]}
                    </div>
                    <div className="absolute top-5 left-1/2 transform -translate-x-1/2 text-xs text-blue-400 whitespace-nowrap">
                      {['3y ago', '1y ago', '8m ago', '3m ago', '2d ago'][index]}
                    </div>
                  </div>
                ))}
                
                {/* Timeline line */}
                <div className="absolute top-1/2 left-0 right-0 transform -translate-y-1/2 h-px bg-slate-700"></div>
              </div>
              
              <div className="mt-6 grid grid-cols-3 gap-4">
                <div className="bg-slate-800/60 p-3 rounded-lg border border-slate-700">
                  <div className="text-xs text-slate-400 mb-1">EMAIL SECURITY EVENTS</div>
                  <div className="flex items-center justify-between">
                    <div className="text-lg font-bold text-white">12</div>
                    <LineChart className="w-5 h-5 text-blue-400" />
                  </div>
                </div>
                <div className="bg-slate-800/60 p-3 rounded-lg border border-slate-700">
                  <div className="text-xs text-slate-400 mb-1">AUTHENTICATION ATTEMPTS</div>
                  <div className="flex items-center justify-between">
                    <div className="text-lg font-bold text-white">47</div>
                    <Lock className="w-5 h-5 text-green-400" />
                  </div>
                </div>
                <div className="bg-slate-800/60 p-3 rounded-lg border border-slate-700">
                  <div className="text-xs text-slate-400 mb-1">CONFIGURATION CHANGES</div>
                  <div className="flex items-center justify-between">
                    <div className="text-lg font-bold text-white">8</div>
                    <Settings className="w-5 h-5 text-yellow-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Action Panel */}
        <div className="bg-slate-900/70 border border-slate-800 rounded-xl p-4 shadow-lg">
          <div className="grid grid-cols-5 gap-3">
            {[
              { label: 'Export Report', icon: FileText, color: 'from-blue-600 to-blue-700' },
              { label: 'Deep Scan', icon: Search, color: 'from-purple-600 to-purple-700' },
              { label: 'Monitor Target', icon: Eye, color: 'from-green-600 to-green-700' },
              { label: 'Threat Analysis', icon: Shield, color: 'from-yellow-600 to-yellow-700' },
              { label: 'Send Alert', icon: BellRing, color: 'from-red-600 to-red-700' }
            ].map((action) => (
              <button 
                key={action.label}
                className={`flex flex-col items-center justify-center p-4 rounded-lg bg-gradient-to-br ${action.color} hover:opacity-90 transition-all text-white`}
              >
                <action.icon className="w-6 h-6 mb-2" />
                <span className="text-sm font-medium">{action.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    )}
    
    {/* Conditional Phone Analysis Section */}
    {activeTab === 'phone' && !loading && (
      <PhoneNumber />
    )}
  </main>
  
 {/* Footer with Terms and Privacy Links */}
 <Footer
        showTermsModal={showTermsModal}
        setShowTermsModal={setShowTermsModal}
        showPrivacyModal={showPrivacyModal}
        setShowPrivacyModal={setShowPrivacyModal}
        showCookiesModal={showCookiesModal}
        setShowCookiesModal={setShowCookiesModal}
        showSupportModal={showSupportModal}
        setShowSupportModal={setShowSupportModal}
      />
</div>
  );
};

export default TraceMaster;
